// Ce fichier est généré automatiquement par scripts/generate-service-registers.js
// Ne pas modifier manuellement - vos changements seront écrasés
// Pour régénérer : pnpm run generate:service-registers

// ==================
// Imports automatiques
// ==================
import { coreServiceRegistry } from "@core/services/register"

// Imports des registries de modules
import { abonnementServiceRegistry } from "@modules/abonnement/services/register"
import { courtageServiceRegistry } from "@modules/courtage/services/register"
import { dataServiceRegistry } from "@modules/data/services/register"
import { energyManagerServiceRegistry } from "@modules/energy-manager/services/register"
import { irveServiceRegistry } from "@modules/irve/services/register"
import { pvServiceRegistry } from "@modules/pv/services/register"
import { usageProfileServiceRegistry } from "@modules/usage-profile/services/register"

// ==================
// Export automatique des types des services core
// ==================
export type * from "@core/services"

// ==================
// Export automatique des types des services de modules
// ==================
export type * from "@modules/abonnement/services"
export type * from "@modules/courtage/services"
export type * from "@modules/data/services"
export type * from "@modules/energy-manager/services"
export type * from "@modules/irve/services"
export type * from "@modules/pv/services"
export type * from "@modules/usage-profile/services"

// ==================
// Export du type Services
// ==================
export type { Services } from "./service"

// ==================
// Registry global (agrégation automatique des registries)
// ==================
export const serviceRegistry = {
    // Services core
    ...coreServiceRegistry,

    // Services des modules
    ...abonnementServiceRegistry,
    ...courtageServiceRegistry,
    ...dataServiceRegistry,
    ...energyManagerServiceRegistry,
    ...irveServiceRegistry,
    ...pvServiceRegistry,
    ...usageProfileServiceRegistry,
} as const

// Type automatique basé sur le registry global
export type ServiceRegistry = typeof serviceRegistry

// Log pour le debug en mode développement
if (import.meta.env.DEV) {
    console.info(
        "[ServiceRegistry] Loaded services:",
        Object.keys(serviceRegistry)
    )
}
